import { BrowserRouter as Router } from "react-router-dom";
import RoutesList from "./routes";

const App: React.FC = () => {
  return (
    <Router>
      {RoutesList}
    </Router>
  );
};

export default App;
